import { d as defineVuesticPlugin } from "../../../services/vue-plugin/utils/define-vuestic-plugin-8c565dfe.mjs";
import { d as defineGlobalProperty } from "../../../services/vue-plugin/utils/global-properties-9524ee5b.mjs";
const vaDropdownPlugin = {
  closeDropdown() {
    let vm = this;
    while (vm = vm.$parent) {
      const name = vm.$options.name;
      if (name === "VaDropdown") {
        vm.hide();
        break;
      }
    }
  }
};
const VaDropdownPlugin = defineVuesticPlugin(() => ({
  install(app) {
    defineGlobalProperty(app, "$closeDropdown", vaDropdownPlugin.closeDropdown);
    defineGlobalProperty(app, "$vaDropdown", vaDropdownPlugin);
  }
}));
export {
  VaDropdownPlugin as V
};
//# sourceMappingURL=index-89360c2b.mjs.map
